export const AnnouncementsTypes = {
    SHOW_ANNOUNCEMENTS: "SHOW_ANNOUNCEMENTS",
    SHOW_GETUSERANNO:"SHOW_GETUSERANNO",
    SHOW_DELETEDANNO:"SHOW_DELETEDANNO",
    SHOW_UPDATEANNO:"SHOW_UPDATEANNO",
    ACTIVATE_ANNO:"ACTIVATE_ANNO",
    DEACTIVATE_ANNO:"DEACTIVATE_ANNO"
  };